import React from "react";

function raisecomplaintlist() {
  return (
    <div>
      <h1>complaint list</h1>
    </div>
  );
}

export default raisecomplaintlist;